import { produce } from 'immer';

const INITIAL_STATE = {
  documents: [],
  loading: false,
};

export default function generalDocuments(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@generalDocuments/GET_GENERAL_DOCUMENTS': {
        draft.loading = true;
        break;
      }
      case '@generalDocuments/GET_GENERAL_DOCUMENTS_SUCCESS': {
        draft.loading = false;
        draft.documents = action.payload.data;
        break;
      }
      case '@generalDocuments/REQUEST_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}
